export * from "-!../../../../node_modules/cache-loader/dist/cjs.js!../../../../node_modules/babel-loader/lib/index.js??ref--2-1!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./FeaturedPeopleListing.vue?vue&type=template&id=0889ad8a&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/FeaturedPeopleListing.vue?vue&type=template&id=0889ad8a&scoped=true
// module id = 280
// module chunks = 0